import { render, staticRenderFns } from "./PurchaseOrderCreditNoteItems.vue?vue&type=template&id=004a12ab&scoped=true&"
import script from "./PurchaseOrderCreditNoteItems.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderCreditNoteItems.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderCreditNoteItems.vue?vue&type=style&index=0&id=004a12ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a12ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
